import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import { SearchScope } from '@amf/shared/components/search/hooks/useAdvancedSearch';
import { SearchResultWithClubFragment } from '@amf/shared/types/graphql';

type Props = {
  item: SearchResultWithClubFragment;
  prefixes: { club: string };
};

function ClubResult({ item, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <Link href={`${prefixes.club}/${item.id}`} passHref>
      <a className='AdvancedSearch__resultItem'>
        {item.brandUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.brandUrl} alt={item.name} className='AdvancedSearch__resultItemImage' />
        ) : (
          <div className='AdvancedSearch__resultItemImage'>{item.name.charAt(0)}</div>
        )}
        <div className='AdvancedSearch__resultItemContent'>
          <div className='AdvancedSearch__resultItemType'>
            {t(`search.scope.${SearchScope.CLUBS}.one`)}
          </div>
          <h3 className='AdvancedSearch__resultItemTitle'>{item.name}</h3>
        </div>
      </a>
    </Link>
  );
}

export default ClubResult;
